import { observer } from 'mobx-react-lite';
import SyntaxHighlighter from '@fengkx/react-syntax-highlighter';
import { atomOneDark } from '@fengkx/react-syntax-highlighter/dist/esm/styles/hljs';
import Markdown from '@/components/markdown';
import { useMcpItemContext } from '../chat-history/context';
import { Skeleton } from 'antd';

const CardCode = observer((props) => {
  const {
    data,
    tool,
    event,
  } = props;

  const highlighterConfig = tool === 'plan' ?  {} : {
    style: atomOneDark,
    showLineNumbers: true,
  }

  const {
    isAITyping,
  } = useMcpItemContext();

  return (
    <div className={[
      "px-24px pr-16px overflow-x-hidden overflow-y-auto scrollbar scrollbar-light rounded-b-15px bg-[#282c34]",
      "!min-h-[260px]",
    ]}>
      {
        event.status == 'running' && isAITyping
        ? <Skeleton active className='antd-dark' />
        : (
          <Markdown
            typing={false}
            text={data}
            components={{
              code({ node, inline, className, children, ...props }) {
                const LANGUAGE_RE = /language-(\w+)/;
                const match = LANGUAGE_RE.exec(className);
                if (match) {
                  return (
                    <SyntaxHighlighter
                      {...props}
                      wrapLongLines
                      className={`text-[12px] leading-relaxed break-words ${tool === 'plan' ? 'code_plan !bg-white' : 'code_execute'}`}
                      customStyle={{
                        fontFamily: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace', 
                      }}
                      {...highlighterConfig}
                      children={String(children).replace(/\n$/, '')}
                      language={match[1]}
                      PreTag="div"
                    />
                  );
                }
              },
            }}
          />
        )
      }
    </div>
  )
});

export default CardCode;